module.exports = __webpack_public_path__ + "static/media/Unassign.8021d55a.svg";